import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { File as FileEnum } from "@funded-here-interface/common/src/constant/enum";

export interface AdminUploadDocumentRequest {
  file: File;
  name: string;
  token: string;
  userId: number;
  fileType: FileEnum;
}

export interface AdminUploadDocumentReponse {
  path: string;
}

const adminUploadDocument = async ({
  file,
  token,
  fileType,
  userId,
  name,
}: AdminUploadDocumentRequest): Promise<AdminUploadDocumentReponse> => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/upload/admin-upload`,
      { file, fileName: name, userId, fileType },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default adminUploadDocument;
